import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { IconButton } from "@mui/material";

import { useAlert } from "../../contexts/AlertContext";

const CopyToClipboardButton: React.FC<{ content: string }> = ({ content }) => {
  const { alert } = useAlert();

  const handleClick = async () => {
    alert.success("Copied to clipboard!");
    await navigator.clipboard.writeText(content);
  };

  return (
    <IconButton
      onClick={handleClick}
      color="primary"
      sx={{
        borderRadius: 0,
      }}
      size="small"
    >
      <ContentCopyIcon fontSize="small" />
    </IconButton>
  );
};

export default CopyToClipboardButton;
